import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Landing after a lead-capture signup submit (Enterprise / Growth / Scale
 * plans). Enterprise-tier signups don't self-serve — the user leaves their
 * details and we come back to them. This screen confirms receipt and sets
 * expectations without pretending anything provisioned.
 */
export function SignUpThanks(): ReactNode {
  const navigate = useNavigate();
  return (
    <Box padding="xxxl">
      <div style={{ maxWidth: 560, margin: '80px auto 0' }}>
        <Container
          header={
            <Header
              variant="h1"
              description="One of the founders will be in touch shortly."
            >
              Thanks — we&apos;ll be in touch within 24 hours.
            </Header>
          }
        >
          <SpaceBetween size="l">
            <Alert type="success">
              We got your request. Kanat or Khassangali will email you personally
              within one business day.
            </Alert>
            <div>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>What happens next</div>
              <ol style={{ margin: 0, paddingLeft: 20, color: '#334155', lineHeight: 1.7 }}>
                <li>We schedule a 20-minute call to understand your setup.</li>
                <li>We walk you through installation on a staging cluster.</li>
                <li>You have a signed workload running before the second call.</li>
              </ol>
            </div>
            <div>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                Or start on the cloud free plan while you wait
              </div>
              <Box color="text-body-secondary" fontSize="body-s">
                Same platform, same API. Anything you build here migrates to your
                on-premises install with one command.
              </Box>
            </div>
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="primary" onClick={() => navigate('/signup?deploy=cloud&plan=free')}>
                Start free on cloud
              </Button>
              <Button variant="link" onClick={() => navigate('/')}>
                Back to home
              </Button>
            </SpaceBetween>
          </SpaceBetween>
        </Container>
      </div>
    </Box>
  );
}
